import { defineStore, storeToRefs } from "pinia"
import { useRoleStore } from "@/store/roles.store.ts"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers.ts"
import { RoleServiceProviderMachine } from "@/models/role-service-provider-machine.model.ts"
import { useRelatedObjectsManager } from "@/composables/socket/related-objects-manager.ts"
import type { Role } from "@/models/role/role.model.ts"
import { computed } from "vue"
import type { RoleServiceProvider } from "@/models/role/role-service-provider.model.ts"

export const useRoleServiceProviderRolesStore = defineStore(
  "roleServiceProviderMachinesStore",
  () => {
    const roleStore = useRoleStore()
    const { roles, rolesServiceProvider } = storeToRefs(roleStore)

    // const

    const roleServiceProviderMachines = computed<RoleServiceProviderMachine[]>(() => {
      const roleServiceProviderMachines = []
      for (const role of rolesServiceProvider.value) {
        roleServiceProviderMachines.push(role.roleServiceProviderMachines)
      }
      return roleServiceProviderMachines.flat()
    })

    const { pushToRelatedObjects, removeFromRelatedObjects } = useRelatedObjectsManager(
      roles,
      (roleServiceProviderMachine: RoleServiceProviderMachine) =>
        roleServiceProviderMachine.roleServiceProvider,
      (role: Role) => role.id!,
      (role: Role) => (role as RoleServiceProvider).roleServiceProviderMachines
    )
    useSocketSynchronizationHandlers(
      RoleServiceProviderMachine,
      null,
      pushToRelatedObjects,
      removeFromRelatedObjects
    )

    return {
      roleServiceProviderMachines,
      pushToRelatedObjects,
      removeFromRelatedObjects
    }
  }
)
